<div #dialog class="dialog" (click)="onOverlayClicked($event)">
  <div class="dialog__content-wrapper" style="overflow: scroll">
    <ng-template #dialogHost></ng-template>
  </div>
</div>
